import * as React from 'react';

import MuiBreadcrumbs from '@mui/material/Breadcrumbs';

import { Link } from '@itp/talent/components/core/link';
import { useBreadcrumbsContext } from '@itp/talent/context/breadcrumbsContext';

export const Breadcrumbs: React.FC = () => {
  const { breadcrumbs } = useBreadcrumbsContext();

  if (!breadcrumbs) {
    return null;
  }

  return (
    <MuiBreadcrumbs
      sx={{
        '& .MuiBreadcrumbs-separator': {
          color: 'text.disabled',
          mx: 0.5,
        },
        alignItems: 'baseline',
        display: 'flex',
        mb: 2,
      }}
      aria-label="breadcrumb"
    >
      {breadcrumbs.links.map((link) => (
        <Link
          sx={{
            '&:hover': { color: 'text.primary' },
            color: 'text.secondary',
            fontSize: '0.8125rem',
            textDecoration: 'none',
          }}
          href={link.url}
          key={link.url}
        >
          {link.name}
        </Link>
      ))}
      <span
        style={{
          color: 'text.secondary',
          fontSize: '0.8125rem',
          fontWeight: 500,
          height: '24px',
        }}
      >
        {breadcrumbs.active}
      </span>
    </MuiBreadcrumbs>
  );
};
